import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import type { BillingSubscribeResponse } from './billing-payment.types';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';

export const useFetchBillingSubscribeSecret = (companyId: string) => {
  const queryClient = useQueryClient();

  return useCallback(async (): Promise<BillingSubscribeResponse | undefined> => {
    if (!companyId) return undefined;

    return queryClient.fetchQuery({
      queryKey: [QueryKey.GET_CLIENT_SECRET, companyId],
      queryFn: () =>
        ApiService.get<BillingSubscribeResponse>({
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'subscribe'],
        }),
      staleTime: 0,
    });
  }, [companyId, queryClient]);
};
